module.exports = __webpack_public_path__ + "static/media/watchNow.ceb92209.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/CXLanding/images/watchNow.png
// module id = 1277
// module chunks = 0